import type { UiKitLinkComponent, UIKitLinkProps } from "@qws-org/ui-kit";
import type { ForwardedRef } from "react";
import { forwardRef } from "react";
// eslint-disable-next-line boundaries/external
import { Link } from "react-router";
import { parseURL } from "ufo";

import { needToNormalize, normalizeUrl } from "~/shared/utils/normalize-url";

function generateUrlWithLocale(path: string, locale: LanguageCode): string {
  const { search, hash, pathname } = parseURL(path);
  let url = `/${locale}${pathname}${search ? `?${search}` : ""}${hash ? `#${hash}` : ""}`;
  if (needToNormalize(url)) {
    url = normalizeUrl(url);
  }
  return url;
}

export const createLinkComponent = function (
  lang: LanguageCode,
): UiKitLinkComponent {
  return forwardRef<HTMLAnchorElement, UIKitLinkProps>(
    ({ children, href, ...rest }, ref: ForwardedRef<HTMLAnchorElement>) => {
      return (
        <Link
          {...rest}
          ref={ref}
          to={
            ["http", "mailto", "tel"].some((proto) => href?.startsWith(proto))
              ? (href ?? "/")
              : generateUrlWithLocale(href ?? "/", lang)
          }
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </Link>
      );
    },
  );
};
